// src/pages/PesquisaJurisprudencia/components/IATab.js
import React from 'react';

const IATab = ({
  descricaoIA,
  setDescricaoIA,
  loadingIA,
  encontrarJurisprudenciaPorIA
}) => {
  return (
    <div className="pesquisa-ia-container">
      <div className="filtros-container">
        <div className="filtros-grid">
          <div className="campo-grupo">
            <label htmlFor="descricao-ia">Descrição para Pesquisa:</label>
            <textarea
              id="descricao-ia"
              className="ia-textarea"
              placeholder="Descreva livremente o caso ou situação jurídica para encontrar jurisprudência relacionada em todos os tribunais disponíveis..."
              value={descricaoIA}
              onChange={(e) => setDescricaoIA(e.target.value)}
              rows={7}
              disabled={loadingIA}
            />
            <small className="texto-ajuda">
              💡 Descreva o caso com o máximo de contexto possível. A IA pesquisará jurisprudência
              relevante em todos os tribunais disponíveis.
            </small>
          </div>
        </div>

        <button
          className="botao-pesquisar"
          onClick={encontrarJurisprudenciaPorIA}
          disabled={loadingIA || !descricaoIA.trim()}
        >
          {loadingIA ? 'Pesquisando...' : 'ENCONTRAR JURISPRUDÊNCIA'}
        </button>
      </div>

      {loadingIA && (
        <div className="ia-loading-banner">
          <span className="ia-loading-icon">🔍</span>
          <div className="ia-loading-text">
            <strong>Realizando Pesquisa em todos tribunais...</strong>
            <span>Isso pode demorar até 1 minuto.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default IATab;